import { FeedbackExplorer } from "./feedback-explorer";

export function AdminFeedbackPage() {
  return (
    <div className="mx-auto max-w-5xl px-6 py-8">
      <FeedbackExplorer />
    </div>
  );
}
